// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d000bfb0","396":"5d115e9d","453":"5f0b049f","455":"635450dd","857":"428d7ef4","977":"701478ca"}[chunkId] + ".chunk.js";
};